import { CANDIDATE_DOCUMENT_TYPES } from "../config/candidateDocumentTypes";

export const MAX_CANDIDATE_DOCUMENT_FILES = 20;
export const MAX_CANDIDATE_DOCUMENT_DRAFT_BYTES = 3 * 1024 * 1024;
export const MAX_CANDIDATE_DOCUMENT_FILE_BYTES = 10 * 1024 * 1024;
export const MAX_CANDIDATE_DOCUMENT_PACKAGE_BYTES = 50 * 1024 * 1024;
export const CANDIDATE_DOCUMENT_DRAFT_CONTENT_TYPES = new Set([
    "image/jpeg",
    "image/png",
    "image/webp",
    "application/pdf",
]);

export function validateCandidateDocumentFile(file) {
    if (!file || !CANDIDATE_DOCUMENT_DRAFT_CONTENT_TYPES.has(file.type)) {
        throw new Error(`Формат файла «${file?.name || "документ"}» не поддерживается`);
    }
    if (!file.size) {
        throw new Error(`Файл «${file.name}» пустой`);
    }
    if (file.size > MAX_CANDIDATE_DOCUMENT_FILE_BYTES) {
        throw new Error(`Файл «${file.name}» превышает 10 МБ. Выберите файл меньшего размера`);
    }
    return file;
}

export function validateCandidateDocumentPackage(files) {
    const selected = Array.from(files || []);
    if (!selected.length) {
        throw new Error("Прикрепите хотя бы один исходный документ");
    }
    if (selected.length > MAX_CANDIDATE_DOCUMENT_FILES) {
        throw new Error(`В одном пакете можно отправить не более ${MAX_CANDIDATE_DOCUMENT_FILES} документов`);
    }
    let totalBytes = 0;
    selected.forEach((file) => {
        validateCandidateDocumentFile(file);
        totalBytes += Number(file.size || 0);
    });
    if (totalBytes > MAX_CANDIDATE_DOCUMENT_PACKAGE_BYTES) {
        throw new Error("Общий размер пакета превышает 50 МБ. Уменьшите размер файлов или удалите лишние документы");
    }
    return { files: selected, totalBytes };
}

const ALLOWED_KINDS = new Set(CANDIDATE_DOCUMENT_TYPES.map((item) => item.value));

export function parseCandidateDocumentsDraft(value) {
    if (!value) return [];
    try {
        const parsed = JSON.parse(value);
        if (!Array.isArray(parsed)) return [];
        return parsed.map((item) => (
            item?.kind === "passport"
                ? { ...item, kind: "passport_personal_data" }
                : item
        )).filter((item) => (
            item
            && typeof item.id === "string"
            && ALLOWED_KINDS.has(item.kind)
            && typeof item.filename === "string"
            && CANDIDATE_DOCUMENT_DRAFT_CONTENT_TYPES.has(item.contentType)
            && Number.isFinite(Number(item.size))
            && Number(item.size) > 0
            && typeof item.dataUrl === "string"
            && item.dataUrl.startsWith(`data:${item.contentType};base64,`)
        )).slice(0, MAX_CANDIDATE_DOCUMENT_FILES);
    } catch {
        return [];
    }
}
